import React from 'react';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Select, Input } from 'antd';
const FormItem = Form.Item;

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = { visible: false, record: {} };
        this.handleClick = this.handleClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
    }
    handleClick(e) {
        this.setState(Object.assign(this.state, { visible: true }, { record: {} }))
    }
    handleCancel(e) { this.setState({ visible: false }) }

    handleSubmit(e) {
        //e.preventDefault();
        let record = this.state.record;
        const { reset, url } = this.props;
        (async (url) => {
            try {
                let response = await fetch(url, {
                    method: 'post', headers: { "Content-type": "application/json" }, body: JSON.stringify(record)
                });
                let result = await response.json();
                if (result.code = 200) {
                    message.success('添加成功');
                    this.setState({ visible: false });
                    reset();
                } else {
                    message.error('添加失败');
                }
            } catch (e) {
                console.log(e);
                message.error('添加失败');
            }
        })(url)
    }

    handleFormChange(changedFields) {
        Object.keys(changedFields).forEach((key, index) => {
            this.state.record[key] = changedFields[key].value;
            this.setState(this.state);
        });
    }
    render() {
        const fields = this.state.record;
        let { metadata } = this.props;
        return (
            <span>
                <Button type="primary" onClick={this.handleClick} >添加</Button>
                <Modal
                    title="添加"
                    footer={null}
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                >
                    <AddForm {...fields} metadata={metadata} onChange={this.handleFormChange} onSubmit={this.handleSubmit} />
                </Modal>
            </span >
        );
    }
}

const AddForm = Form.create({
    onFieldsChange(props, changedFields) {
        props.onChange(changedFields);
    },
    onValuesChange(_, values) {
        //console.log(values);
    }
})((props) => {
    const { getFieldDecorator } = props.form;
    const { metadata } = props;
    // const handleReset = () => {
    //     props.form.resetFields();
    // }
    const validateFields = (e) => {
        e.preventDefault();
        props.form.validateFields((err, values) => {
            if (!err) {
                props.onSubmit();
            }
        });
    }
    return (
        <Form onSubmit={validateFields}>
            {metadata.map((meta, index) => {
                switch (meta.type) {
                    case 'Input':
                        return <FormItem label={meta.label}  >
                            {getFieldDecorator(meta.field, {
                                rules: [{ required: meta.isRequired ? meta.isRequired : false, message: meta.label + '是必须的!' }],
                            })(
                                <Input
                                    key={index}
                                    addonBefore={meta.addonBefore}
                                    placeholder={meta.placeholder} />)}
                        </FormItem>;
                    case 'Select': return <FormItem label={meta.label}  >
                        {getFieldDecorator(meta.field)(
                            <Select placeholder={meta.placeholder} >
                                {meta.options.map((item, index) => {
                                    return <Option key={index} value={
                                        item.split("|").length > 1 ? item.split("|")[1] : item
                                    }>{
                                        item.split("|").length > 1 ? item.split("|")[0] : item
                                    }</Option>
                                })}
                            </Select>)}
                    </FormItem>;
                }
            })}
            <Button type="primary" htmlType="submit">Submit</Button>
            {/*<Button type="primary" onClick={this.handleReset} >clear</Button>*/}
        </Form>
    );
});




// WEBPACK FOOTER //
// ./utils/add.js